import React, { useState } from "react";
import UserProgress from "../components/Programs/UserProgress";
import Aside from "../modules/SideNav/Aside";

function UserProgressLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <UserProgress handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default UserProgressLayout;
